import React, { useState } from "react"
import "./style/home-versions.scss"
import { useStore } from "react-redux"
import selectAppVersions from "@app/helpers/selectAppVersions"
import { LocalStorage } from "@ng-mw/shared-react-components"
import MenyLocalStorage from "@app/MenyLocalStorage"
import classNames from "classnames"

const HomeVersions = () => {
    const appVersions = selectAppVersions(useStore())
    const [isEnabled, setIsEnabled] = useState(
        !!LocalStorage.get(MenyLocalStorage.UserEnabledNewCorporateFlow),
    )

    // Format text
    const nativeAppVersion = appVersions.nativeAppVersion || ""
    const webAppVersion = appVersions.webAppVersion || ""
    const versionText = `v${nativeAppVersion} (${webAppVersion})`

    const toggleCorporateFlow = () => {
        if (isEnabled) {
            LocalStorage.remove(MenyLocalStorage.UserEnabledNewCorporateFlow)
            setIsEnabled(false)
        } else {
            LocalStorage.set(MenyLocalStorage.UserEnabledNewCorporateFlow, "true")
            setIsEnabled(true)
        }
    }

    const debugToggler = classNames("app-home-versions__debug-button", {
        "app-home-versions__debug-button--enabled": isEnabled,
        "app-home-versions__debug-button--disabled": !isEnabled,
    })

    return (
        <div className="app-home-versions">
            <span className="app-home-versions__text">{versionText}</span>
            <button
                onClick={toggleCorporateFlow}
                className={debugToggler}
            ></button>
        </div>
    )
}

export default HomeVersions
